import { shallowRef, triggerRef } from 'vue'

const nativeSystemCulture = shallowRef(undefined)

if (typeof window !== 'undefined') {
  // Invalidate date computations when browser preferences change during this session.
  const onLanguageChange = () => triggerRef(nativeSystemCulture)
  window.addEventListener('languagechange', onLanguageChange)
  import.meta.hot?.dispose(() => window.removeEventListener('languagechange', onLanguageChange))
}

export const normalizeSystemCulture = (value) => {
  if (typeof value !== 'string' || !value.trim()) return undefined

  try {
    return new Intl.Locale(value.trim()).toString()
  } catch {
    return undefined
  }
}

export const setNativeSystemCulture = (value) => {
  nativeSystemCulture.value = normalizeSystemCulture(value)
}

export const getSystemLocales = () => {
  const locales = [nativeSystemCulture.value]

  if (typeof navigator !== 'undefined') {
    if (Array.isArray(navigator.languages)) locales.push(...navigator.languages)
    locales.push(navigator.language)
  }

  try {
    locales.push(Intl.DateTimeFormat().resolvedOptions().locale)
  } catch {
    // A missing runtime locale must not block an API request.
  }

  return locales
}

// Translation language and registration country do not override the system culture.
export const getSystemCulture = (fallbackLocale, systemLocales = getSystemLocales()) => {
  for (const locale of Array.isArray(systemLocales) ? systemLocales : []) {
    const culture = normalizeSystemCulture(locale)
    if (culture) return culture
  }

  return normalizeSystemCulture(fallbackLocale)
}
